import * as React from "react";
import { Button, Form, FormGroup } from "reactstrap";
import ErrorMessage from "../../ErrorMessage";
import useErrorHandler from "../../../utils/Hooks/ErrorHandler";
import { authEndpoints } from "../../../utils/Constants";
import { useAlert } from "../../../Services/AlertContext";
import { useParams } from "react-router-dom";
import PasswordInput from "../../Editors/PasswordInput";
import fetch from 'cross-fetch';

const checkPassword = (
    password1, password2,
    setError
) => {
    if (password1 !== password2) {
        setError("Both fields must be the same");
        return false;
    }
    // Validate email
    if (password1.length < 6) {
        setError("Your password must be at least 6 characters long.");
        return false;
    }
    return true;
};


const ResetPasswordPanel = ({ onClose }) => {
    const [password1, setPassword1] = React.useState("");
    const [password2, setPassword2] = React.useState("");
    const { id, item } = useParams();
    const [loading, setLoading] = React.useState(false);
    const { error, showError } = useErrorHandler(null);

    const alert = useAlert();

    return <Form
        onSubmit={async e => {
            e.preventDefault();
            if (checkPassword(password1, password2, showError)) {
                setLoading(true);
                const res = await fetch(authEndpoints.resetUserPassword,
                    {
                        method: "POST",
                        headers: { "Content-type": "application/json", Authorization: `Bearer ${item}` },
                        body: JSON.stringify({ id, token: item, password: password1 })
                    }
                );
                if (res) {
                    const result = await res.json();

                    alert({

                        title: <h3>Password Reset</h3>, body: <div>
                            <h5>{result.success ? "Password Reset" : "Failed to reset password"}</h5>
                            {result.messages && result.messages.length ? result.messages.map(x => <p>{x}</p>) : null}
                        </div>
                        , onDismiss: () => {
                            onClose();

                        }
                    });
                } else {
                    alert({
                        title: <h3>Hmmm....</h3>,
                        body: <h5>We couldn't reset your password.</h5>,
                        onDismiss: () => { onClose(); }
                    })
                }


            }
        }}
    >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
            <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
            <div style={{ width: '80%' }}>
                <h3 style={{ marginTop: '5vh', marginBottom: '5vh' }}>Forgot  Password</h3>
                <FormGroup>
                    <PasswordInput size='lg'
                        type="password"
                        name="password1"
                        value={password1}
                        placeholder="your password"
                        onChange={e => setPassword1(e.target.value)}
                    />

                </FormGroup>
                <FormGroup>
                    <PasswordInput size='lg'
                        type="password"
                        name="password2"
                        value={password2}
                        placeholder="repeat password"
                        onChange={e => setPassword2(e.target.value)}
                    />
                </FormGroup>

            </div>
        </div>
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{ marginBottom: '50px', width: '80%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Button style={{ width: '40%' }} color='primary' type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Send Email"}
                </Button>
                <Button style={{ width: '40%' }} color='secondary' type='button' onClick={onClose} disabled={loading} >Go Back</Button>
                {error && <ErrorMessage errorMessage={error} />}
            </div>
        </div>
    </Form>
}

export default ResetPasswordPanel;